/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MdAccountBox, MdDone } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, TextField } from '@material-ui/core';

import CardSideBordered from '~/components/CardSideBordered';
import FormPasswordInput from '~/components/Form/PasswordInput';
import LocaleMessage from '~/components/LocaleMessage';
import PageBody from '~/components/PageBody';

import api from '~/services/pluginbot-api';

export default function SignUp() {
    const [submitted, setSubmitted] = useState(false);

    const settings = useSelector(state => state.settings);
    const { pluginspace } = settings;

    const [isLoading, setIsLoading] = useState(!pluginspace);

    const [body, setBody] = useState({});

    function requestError(error) {
        if (error.response) {
            const message = (
                <LocaleMessage msg={`errors.${error.response.data.code}`} />
            );
            toast.error(message);
        } else if (error.request) {
            toast.error(<LocaleMessage msg="errors.request" />);
        } else {
            toast.error(<LocaleMessage msg="errors.unknown" />);
        }
        setIsLoading(false);
    }

    async function handleSubmit(event) {
        event.preventDefault();

        const data = { ...body };

        setIsLoading(true);

        await api
            .post(`/users/register`, data)
            .then(() => {
                setIsLoading(false);
                setSubmitted(true);
            })
            .catch(error => {
                requestError(error);
            });
    }

    function handleNewUser() {
        const { id } = pluginspace;
        setBody({ pluginspace_id: id });
        setSubmitted(false);
    }

    useEffect(() => {
        handleNewUser();
    }, [pluginspace]);

    function confirmSubmit() {
        return (
            <div className="row full-body">
                <div className="col-md-6 col-12 mb-5">
                    <CardSideBordered
                        title={
                            <LocaleMessage msg="page.sign_up.form.label.register" />
                        }
                        Icon={MdAccountBox}
                        hide
                    >
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <MdDone size={60} style={{ margin: '20px' }} />
                                <h2 className="mt-4">
                                    <LocaleMessage msg="page.sign_up.form.label.submitted" />
                                </h2>
                                <p>
                                    <LocaleMessage msg="page.sign_up.form.label.wait_admin" />
                                </p>
                            </div>
                            <Button
                                className="p-3 mt-4"
                                variant="contained"
                                color="primary"
                                onClick={event => handleNewUser(event)}
                                fullWidth
                                size="large"
                            >
                                <LocaleMessage msg="page.sign_up.form.label.new" />
                            </Button>
                            <div
                                className="mt-4"
                                style={{ textAlign: 'center' }}
                            >
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    disabled={isLoading}
                                >
                                    <Link to="/login">
                                        <LocaleMessage msg="page.sign_up.form.label.login" />
                                    </Link>
                                </Button>
                            </div>
                        </>
                    </CardSideBordered>
                </div>
            </div>
        );
    }

    return (
        <PageBody loading={isLoading}>
            <>
                {!submitted ? (
                    <form
                        className="row full-body"
                        noValidate
                        autoComplete="off"
                    >
                        <div className="col-md-8 col-12 mb-5">
                            <CardSideBordered
                                title={
                                    <LocaleMessage msg="page.sign_up.form.label.register" />
                                }
                                Icon={MdAccountBox}
                                hide
                            >
                                <>
                                    <div
                                        className="row"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            className="col-md-8 col-12 mb-5"
                                            style={{ textAlign: 'center' }}
                                        >
                                            <Link to="/login">
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    disabled={isLoading}
                                                >
                                                    <LocaleMessage msg="page.sign_up.form.label.login" />
                                                </Button>
                                            </Link>
                                        </div>
                                        <div className="col-md-8 col-12 mb-5">
                                            <TextField
                                                id="user-name"
                                                label={
                                                    <LocaleMessage msg="page.sign_up.form.label.name" />
                                                }
                                                fullWidth
                                                value={body.name || ''}
                                                onChange={event =>
                                                    setBody({
                                                        ...body,
                                                        name:
                                                            event.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        <div className="col-md-8 col-12 mb-5">
                                            <TextField
                                                id="user-email"
                                                label={
                                                    <LocaleMessage msg="page.sign_up.form.label.email" />
                                                }
                                                fullWidth
                                                value={body.email || ''}
                                                onChange={event =>
                                                    setBody({
                                                        ...body,
                                                        email:
                                                            event.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        <div className="col-md-8 col-12 mb-5">
                                            <FormPasswordInput
                                                label={
                                                    <LocaleMessage msg="page.sign_up.form.label.password" />
                                                }
                                                fullWidth
                                                value={body.password || ''}
                                                onChange={event =>
                                                    setBody({
                                                        ...body,
                                                        password:
                                                            event.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        <div className="col-md-8 col-12 mb-5">
                                            <FormPasswordInput
                                                label={
                                                    <LocaleMessage msg="page.sign_up.form.label.confirm_password" />
                                                }
                                                fullWidth
                                                value={
                                                    body.confirmPassword || ''
                                                }
                                                onChange={event =>
                                                    setBody({
                                                        ...body,
                                                        confirmPassword:
                                                            event.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                </>
                            </CardSideBordered>
                        </div>
                        <div className="col-md-8 col-12 mb-5">
                            <Button
                                className="p-3"
                                variant="contained"
                                color="primary"
                                onClick={event => handleSubmit(event)}
                                fullWidth
                                size="large"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <LocaleMessage msg="page.sign_up.form.label.submitting" />
                                ) : (
                                    <LocaleMessage msg="page.sign_up.form.label.register" />
                                )}
                            </Button>
                        </div>
                    </form>
                ) : (
                    confirmSubmit()
                )}
            </>
        </PageBody>
    );
}
